import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BsExclamation } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { masterDataActions } from "../../actions/masterData.action";
import ConfirmDialog from "../common/ConfirmDialog/ConfirmDialog";
import Form from "../common/Form/From";
import useModal from "../Hooks/useModal";
import UpdateMasterForm from "../MasterDataForm/UpdatemasterDataForm";
import styles from "./Skills.module.scss"
import * as yup from "yup";
import ModalDialog from "../common/Modal/Modal";
import Loader from "../common/Loader/Loader";
import NoDataFond from "../common/noDatafound/noDataPage";

const SkillsComponent = (props) => {
    const { toggle: updateMasterDataToggle, visible: updateMasterVisible } = useModal();
    let { toggle: ConfirmToggle, visible: ConfirmModal } = useModal();
    const [deleteId, setDeleteId] = useState(null);
    const [editedData, setEditedData] = useState(null);
    const [loading, setLoading] = useState(true)
    const skills = useSelector((state) => state.masterData.skills);
    const dispatch = useDispatch();
    const [initialValues, setInitialValues] = useState({
        name: "",
        type: "",
        parentId: ""
    });

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1000);
    })

    useEffect(() => {
        if (editedData !== null && editedData?.id) {
            setInitialValues({
                name: editedData?.name,
                type: editedData?.type
            })
            updateMasterDataToggle()
        }
    }, [editedData])

    useEffect(() => {
        if (!updateMasterVisible) {
            setEditedData(null)
        }
    }, [updateMasterVisible])

    const deleteSkills = (id) => {
        if (id) {
            dispatch(masterDataActions.deleteMasterData(id, `type=skills`));
            setDeleteId(null)
            ConfirmToggle();
            setTimeout(() => {
                dispatch(masterDataActions.getSkills())
            }, 100)

        }
    };

    const handleSubmit = (values) => {
        if (values && editedData !== null) {
            dispatch(masterDataActions.updateMasterData(values, editedData?.id)).then((res) => {
                if (res) {
                    updateMasterDataToggle()
                    if (values?.type === "skills") {
                        props?.setActiveTab(false)
                    } else {
                        props?.setActiveTab(true)
                    }
                    dispatch(masterDataActions.getSkills())
                }
            })
        }
    }

    const renderForm = (errors, touched) => {
        return (
            <UpdateMasterForm
                errors={errors}
                touched={touched}
                editedData={editedData}
            />
        );
    };


    const masterSchema  = yup.object().shape({
        type: yup.string().required("Type is required"),
        name: yup.string().required("Required"),
    });
    return (
        skills && skills.length > 0 ?
            <><div className={styles.skillMain}>
                {skills?.map((val) => {
                    return (
                        <div className={styles.chipPart} id={`skillsPart_${val?.id}`}>
                            <div className={styles.textPart} onClick={() => {
                                setEditedData(val);
                            }}>
                                {val?.name}
                            </div>
                            <AiOutlineClose onClick={() => {
                                setDeleteId(val?.id)
                                ConfirmToggle();
                            }} className={styles.closeBtn} />
                        </div>
                    );
                })}
            </div>
                <ConfirmDialog
                    visible={ConfirmModal}
                    toggle={ConfirmToggle}
                    title="Are you sure you want to delete?"
                    activeBtnClick={() => {
                        deleteSkills(deleteId);
                    }}
                >
                    <div className={`confirmIcon rounded-circle`}>
                        <BsExclamation style={{ fontSize: 42 }} />
                    </div>
                </ConfirmDialog>
                <ModalDialog
                    toggle={updateMasterDataToggle}
                    title={`${editedData !== null ? "Update" : "Add"} Master Data`}
                    visible={updateMasterVisible}
                    size="md"
                    bodyClass="p-0"
                >
                    <Form
                        initialValues={initialValues}
                        validationSchema={masterSchema}
                        handleSubmit={handleSubmit}
                        renderForm={renderForm}
                    />
                </ModalDialog>
            </>
            :
            loading ?
                <Loader color={"#5382ba"} />
                : <NoDataFond />
    )
}

export default SkillsComponent;